import axios from "axios";
import { resolveTenantId } from "../utils/tenant";

// === Base URL ===
// export const BASE_URL = "http://localhost:4001";
export const BASE_URL = "https://hr-software-bm6w.onrender.com";

// === Auth URLs ===
export const LOGIN_URL = `${BASE_URL}/api/v1/auth/login`;
export const REGISTER_URL = `${BASE_URL}/api/v1/auth/register`;
export const FORGOT_PASSWORD_URL = `${BASE_URL}/api/v1/auth/forgot-password`;
export const RESET_PASSWORD_URL = `${BASE_URL}/api/v1/auth/reset-password`;

// === User CRUD (Protected) ===
export const USERS_URL = `${BASE_URL}/api/v1/auth/users`; // for list, create, update, delete

// === Axios instance ===
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Set token from localStorage if available
const token = localStorage.getItem("token");
if (token) {
  api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

// Request interceptor for API calls
api.interceptors.request.use(
  (config) => {
    config.headers = config.headers || {};

    // Get token from localStorage
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const tenantId = resolveTenantId();
    if (tenantId) {
      config.headers["X-Tenant-ID"] = tenantId;
      config.headers["x-company-slug"] = tenantId;
    } else {
      delete config.headers["X-Tenant-ID"];
      delete config.headers["x-company-slug"];
    }

    console.log(
      `🌐 Making ${config.method.toUpperCase()} request to: ${config.url}`,
      `| Tenant: ${config.headers["X-Tenant-ID"] || "none"}`,
    );
    return config;
  },
  (error) => {
    console.error("❌ Request error:", error);
    return Promise.reject(error);
  },
);

// Response interceptor for API calls
api.interceptors.response.use(
  (response) => {
    console.log(`✅ Response from ${response.config.url}:`, response.status);
    return response;
  },
  (error) => {
    const status = error.response?.status || error.status;
    const message = error.response?.data?.message || error.message;
    const errorCode = error.response?.data?.error;

    console.error(`❌ Error response:`, {
      status: status,
      errorCode: errorCode,
      message: message,
      url: error.config?.url,
      fullError: error,
    });

    if (status === 404 && errorCode === "TENANT_NOT_FOUND") {
      window.dispatchEvent(new Event("tenant-not-found"));
    }

    // Handle invalid or expired token (401 Unauthorized)
    if (
      status === 401 ||
      message?.includes("Invalid") ||
      message?.includes("expired")
    ) {
      console.warn(
        `🔐 401 Unauthorized detected - Clearing session and logging out`,
      );

      // Clear all auth-related data from localStorage
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("company");
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("company");

      // Clear axios default auth header
      delete api.defaults.headers.common["Authorization"];

      // Dispatch custom logout event to trigger React state update
      // This will cause AppRoutes to re-evaluate and show login page
      console.log("🔐 Dispatching logout event...");
      window.dispatchEvent(new Event("logout"));
    }
    return Promise.reject(error);
  },
);

export default api;
